export class OccMap
{
	occMapId: number;
	occMapDate: Date;
}
